import React, { memo } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import withCreateMenu from '../../containers/CreateMenu';
import { Checkbox } from '../../styles/customComponents';
import { formatPrice } from '../../helpers/price';

const ProductListItem = memo(props => {
  const { data, fatherId, toggleProduct, handleChangeQuantity, isUhuuMtkpc, toggleItem } = props;
  return (
    <styles.ProductItem>
      <styles.LeftInfo>
        <Checkbox
          id={`check-item-${data.id}`}
          name={`check-item-${data.id}`}
          checked={!!data.checked}
          disabled={!!data.disabled}
          onClick={
            !data.disabled
              ? () =>
                  toggleItem ? toggleItem(fatherId, data.id) : toggleProduct(fatherId, data.id)
              : null
          }
          customStyles={{ paddingLeft: 0 }}
        />
        <styles.ProductName>
          {data.name}
          {!!data.disabled && <styles.ProductWarning>{data.disabledText}</styles.ProductWarning>}
        </styles.ProductName>
      </styles.LeftInfo>
      <styles.RightInfo>
        <styles.ProductPrice>
          <styles.Label>Preço</styles.Label>
          <styles.Value>{formatPrice(data.originalPrice / 100)}</styles.Value>
        </styles.ProductPrice>
        {isUhuuMtkpc() && (
          <styles.Quantity>
            <styles.Label>Qtd</styles.Label>
            <styles.CustomInput
              id={`inp-qtty-${data.id}`}
              type="text"
              name={`inp-qtty-${data.id}`}
              onChange={e => handleChangeQuantity(fatherId, data.id, e, data.quantity)}
              disabled={!data.checked}
              value={data.quantity}
            />
          </styles.Quantity>
        )}
      </styles.RightInfo>
    </styles.ProductItem>
  );
});

ProductListItem.propTypes = {
  data: PropTypes.object,
  fatherId: PropTypes.number,
  handleChangeQuantity: PropTypes.func,
  toggleProduct: PropTypes.func,
  checkValidChars: PropTypes.func,
  isUhuuMtkpc: PropTypes.func,
};

export default withCreateMenu(ProductListItem);



// WEBPACK FOOTER //
// ./src/components/ProductListItem/index.js